<template>
  <div class="w-full h-full flex">
    <div
      class="absolute pointer-events-none w-full h-full flex items-center justify-center"
    >
      <div class="w-full h-[100%] absolute">
        <ImgComponent
          src="/images/welcome/bgStars.svg"
          alt=""
          class="w-full h-full object-cover"
        />
      </div>
      <div
        class="absolute top-[45%] -translate-y-[50%] w-[60%] md:w-[40%] aspect-square opacity-10"
      >
        <ImgComponent
          src="/images/welcome/circlebg.svg"
          class="object-contain w-full h-full"
        />
      </div>
      <div
        class="absolute top-[45%] -translate-y-[50%] w-[15%] md:w-[10%] aspect-square"
      >
        <ImgComponent
          src="/images/welcome/1xBetIco.svg"
          class="object-contain w-full h-full"
        />
      </div>
      <div
        class="absolute top-[49%] -translate-y-[50%] left-[62%] md:left-[58%] w-[10%] md:w-[8%] aspect-square"
      >
        <ImgComponent
          src="/images/welcome/1winIcon.svg"
          class="object-contain w-full h-full"
        />
      </div>
      <div
        class="absolute top-[45%] -translate-y-[50%] right-[62%] md:right-[58%] w-[10%] md:w-[8%] aspect-square"
      >
        <ImgComponent
          src="/images/welcome/betwinner.png"
          class="object-contain w-full h-full"
        />
      </div>
      <div
        class="absolute top-[35%] -translate-y-[50%] left-[53%] md:left-[50%] w-[10%] md:w-[8%] aspect-square"
      >
        <ImgComponent
          src="/images/welcome/melbetIcon.svg"
          class="object-contain w-full h-full"
        />
      </div>
      <div
        class="absolute top-[15%] -translate-y-[50%] -rotate-[40deg] left-[0%] w-[15%] md:w-[10%] aspect-square"
      >
        <ImgComponent
          src="/images/welcome/eightStarz.png"
          class="object-contain w-full h-full rounded-xl"
        />
      </div>
      <div
        class="absolute top-[15%] -translate-y-[50%] rotate-[40deg] right-[0%] w-[15%] md:w-[10%] aspect-square"
      >
        <ImgComponent
          src="/images/welcome/usdtIcon.svg"
          class="object-contain w-full h-full"
        />
      </div>
    </div>
    <div class="mt-auto w-full p-6 md:p-8 relative mb-12">
      <div
        class="w-[90%] md:w-[80%] max-w-2xl mx-auto text-xl md:text-2xl text-center font-bold"
      >
        Recharge par mobile Money tes comptes
      </div>
      <div class="py-3"></div>
      <div
        class="w-[90%] md:w-[80%] max-w-2xl mx-auto text-center text-sm md:text-base font-medium"
      >
        Recharge par Mobile Money tes comptes & <br />
        échange tes cryptos à bon prix
      </div>
      <div class="py-6 md:py-12"></div>
      <div class="flex justify-center">
        <router-link class="buttonComponent" to="/login">
          Connexion
        </router-link>
      </div>
    </div>
  </div>
</template>
